if (typeof newArrivalsCarrusel !== 'function') {
    class newArrivalsCarrusel extends HTMLElement {
        constructor() {
            super();
            this.galleries = this.querySelectorAll('[carrusel-new-arrivals]');
            this.tabsTriggers = this.querySelectorAll('[data-trigger-tab]');
            this.contentsTabs = this.querySelectorAll('[data-content-carrusel]');
            this.waitForSlick();
            this.initListener();     
        }

        initListener() {
            if(this.tabsTriggers) {
                 this.tabsTriggers.forEach((trigger) => {
                    trigger.addEventListener('click', (e) => {
                        const target = trigger.getAttribute('data-trigger-tab');
                        this.handleCarrusel(target);
                    })
                 })
            }
        }

        handleCarrusel(data) {
            this.tabsTriggers.forEach((button) => {
                if (button.getAttribute('data-trigger-tab') === data) {
                    button.classList.add('active');
                } else {
                    button.classList.remove('active');
                }
            })
            if (this.contentsTabs) {
                this.contentsTabs.forEach((ele) => {
                    if (ele.getAttribute('data-content-carrusel') === data) {
                        ele.setAttribute('aria-hidden', false);
                    } else {
                        ele.setAttribute('aria-hidden', true);
                    }
                })
            }
        }

        waitForSlick() {
            const checkSlicknA = setInterval(() => {
                if (window.jQuery && typeof jQuery.fn.slick !== 'undefined') {
                    clearInterval(checkSlicknA);
                    this.initSlick();
                }
            }, 100);
        }

        initSlick() {
            if (!this.galleries) return;

            this.galleries.forEach((gallery) => {
                if (window.jQuery) {
                    jQuery(gallery).slick({
                        dots: false,
                        arrows: true,
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        speed: 300,
                        autoplay: true,
                        autoplaySpeed: 8000,
                        responsive: [
                            {
                                breakpoint: 1180,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    arrows: false,
                                    dots: false,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 2.1,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    arrows: false,
                                    dots: false,
                                    infinite: false
                                }
                            }
                        ]
                    });
                }

            })
            
            
        }
    }
    if (typeof customElements.get('adrnl-home-new-arrivals') === 'undefined') {
        customElements.define('adrnl-home-new-arrivals', newArrivalsCarrusel);
    }
}